import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { partnerPortalApi } from '../../api/partnerPortal';

export function PartnerVerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState<'checking' | 'success' | 'error'>('checking');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('No verification token was provided.'); return; }
    partnerPortalApi.verifyEmail(token)
      .then((result) => { setStatus('success'); setMessage(result.data.message); })
      .catch((err) => { setStatus('error'); setMessage(err instanceof Error ? err.message : 'Verification failed.'); });
  }, [token]);

  return (
    <div className="login-page">
      <div className="card" style={{ maxWidth: 440, margin: '80px auto', borderTop: '4px solid var(--vri-green)' }}>
        <h1>Email Verification</h1>
        {status === 'checking' && <p className="muted">Verifying…</p>}
        {status !== 'checking' && <p className={status === 'error' ? 'field-error' : undefined}>{message}</p>}
        <p className="muted" style={{ marginTop: '1.5em' }}><Link to="/login">Return to sign in</Link></p>
      </div>
    </div>
  );
}
